import { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useQuery } from "@apollo/client";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  FormHelperText,
  Stack,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import moment from "moment";
//Import from project
import { useMutation } from "@apollo/client";
import "../../../Style/dialogstyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { DialogTitleComp } from "../../../Utils/Component";
import {
  SelectStudent,
  SelectEnrollmentByStudent,
} from "../../../Components/Include/DynamicSelect/DynamicSelect";
import {
  CREATE_INVOICE,
  GET_NEXT_INVOICE_ID,
  // CREATE_ALERT_PAYMENT,
} from "../../../Schema/Invoice";
import ItemList from "./ItemList";
import AlertList from "./AlertList";
import {
  currencyFormat,
  currencyFormatRiel,
  generateInvoiceNumber,
  // sumTwoNumber,
  minuseTwoNumber,
} from "../../../Function/DynamicFn";
// import useGetExchangeRate from "../../../Hooks/useGetExchangeRate";

export default function InvoiceForm({
  studentId,
  open,
  setRefetch,
  handleClose,
  hideBackdrop,
  dialogTitle,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);

  // const { exchangeRateData } = useGetExchangeRate();
  // console.log("exchangeRateData::", exchangeRateData);

  const exchangeRateFromLocal = JSON.parse(
    window.localStorage.getItem("exchangeRateFromLocal"),
  );

  const [loading, setLoading] = useState(false);
  const [required, setRequired] = useState(false);
  const [inputType, setInputType] = useState("dollar");
  const [inputReceivedAmount, setInputReceivedAmount] = useState(0);
  const [receivedAmount, setReceivedAmount] = useState(0);
  const [checkType, setCheckType] = useState("student");
  const [exchangeRate, setExchangeRate] = useState(
    exchangeRateFromLocal ? exchangeRateFromLocal : 4000,
  );

  const newItem = {
    groupFeeId: { id: "", title: "", price: "" },
    startDate: null,
    endDate: null,
    discountType: "amount",
    discount: 0,
    qty: 1,
    price: 0,
  };

  const [listItemData, setListItemData] = useState([newItem]);

  // const alertItem = {
  //   paidAmount: 0,
  //   alertDate: moment(),
  //   status: "",
  // };

  const [alertItemData, setAlertItemData] = useState([]);
  // console.log("alertItemData::", alertItemData);

  const { data } = useQuery(GET_NEXT_INVOICE_ID);

  const totalAmount = listItemData?.reduce((sum, item) => {
    const price = parseFloat(item?.groupFeeId?.price * item?.qty || 0);
    const discount = parseFloat(item?.discount || 0);

    let finalAmount = price;

    if (item.discountType === "percent") {
      finalAmount = price - (price * discount) / 100;
    } else {
      finalAmount = price - discount;
    }

    return sum + finalAmount;
  }, 0);

  // console.log("checkType::", checkType);

  // const [createAlertPayment] = useMutation(CREATE_ALERT_PAYMENT, {
  //   onCompleted: ({ createAlertPayment }) => {
  //     setLoading(false);
  //     if (createAlertPayment?.isSuccess === true) {
  //       setAlert(true, "success", createAlertPayment?.message);
  //     } else {
  //       setAlert(true, "error", createAlertPayment?.message);
  //     }
  //   },
  //   onError: ({ message }) => {
  //     setLoading(false);
  //     setAlert(true, "error", { messageKh: message, messageEn: message });
  //   },
  // });

  const [createInvoice] = useMutation(CREATE_INVOICE, {
    onCompleted: ({ createInvoice }) => {
      setLoading(false);
      if (createInvoice?.isSuccess === true) {
        setRefetch();
        setAlert(true, "success", createInvoice?.message);
        handleClose();
        resetForm();
        // if (alertItemData?.length > 0) {
        //   alertItemData?.map((data) => {
        //     createAlertPayment({
        //       variables: {
        //         input: {
        //           // invoiceId:
        //           alertDate: data?.alertDate,
        //           paidAmount: 0,
        //           status: "",
        //         },
        //       },
        //     });
        //   });
        // }
      } else {
        setAlert(true, "error", createInvoice?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const validationSchema = Yup.object().shape({
    // receivedAmount: Yup.number().min(0).max(totalAmount),
    invoiceType: Yup.string().required(t("required")),
    studentId: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string(),
    }),
    // enrollmentId: Yup.object().shape({
    //   id:
    //     checkType === "student"
    //       ? Yup.string().required(t("required"))
    //       : Yup.string(),
    //   title:
    //     checkType === "student"
    //       ? Yup.string().required(t("required"))
    //       : Yup.string(),
    // }),

    enrollmentId: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string(),
    }),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      // receivedAmount: 0,
      invoiceType: "student",
      studentId: { id: "", title: "" },
      enrollmentId: { id: "", title: "" },
      remark: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const isRequire = listItemData.filter((e) => !e?.groupFeeId?.id);
      if (isRequire.length > 0) {
        setRequired(true);
        return;
      } else {
        setRequired(false);
      }
      setLoading(true);
      const alertData = alertItemData?.map((e) => ({
        paidAmount: 0,
        alertDate: moment(e?.alertDate).format("YYYY-MM-DD"),
        status: "",
      }));
      // console.log(first)
      createInvoice({
        variables: {
          alertPayments: alertData,
          input: {
            ...values,
            receivedAmount: receivedAmount,
            totalAmount: totalAmount,
            studentId: values?.studentId?.id,
            enrollmentId: values?.enrollmentId?.id
              ? values?.enrollmentId?.id
              : null,
            exchangeRate: parseFloat(exchangeRate),
            items: listItemData?.map((e) => {
              const price = parseFloat(e?.price * e?.qty || 0);
              const discount = parseFloat(e?.discount || 0);

              const amount =
                e?.discountType === "percent"
                  ? price - (price * discount) / 100
                  : price - discount;

              return {
                discountType: e?.discountType,
                startDate: e?.startDate
                  ? moment(e?.startDate).format("YYYY-MM-DD")
                  : null,
                endDate: e?.startDate
                  ? moment(e?.endDate).format("YYYY-MM-DD")
                  : null,
                price: parseFloat(e?.price),
                qty: parseFloat(e?.qty),
                discount: parseFloat(e?.discount || 0),
                groupFeeId: e?.groupFeeId?.id,
                amount,
              };
            }),
          },
        },
      });
    },
  });

  const {
    validateField,
    values,
    errors,
    touched,
    resetForm,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  } = formik;

  // console.log("values::", values)

  useEffect(() => {
    resetForm();
  }, [open]);

  useEffect(() => {
    if (values.studentId?.id) {
      validateField("enrollmentId");
    }
  }, [values.studentId?.id]);

  useEffect(() => {
    if (studentId) {
      setFieldValue("studentId", {
        id: studentId,
        title: studentId,
      });
    }
  }, [studentId]);

  useEffect(() => {
    if (values.invoiceType) {
      setCheckType(values.invoiceType);
    }
  }, [values.invoiceType]);

  useEffect(() => {
    if (exchangeRate) {
      // setExchangeRate(exchangeRate);
      localStorage.setItem(
        "exchangeRateFromLocal",
        JSON.stringify(exchangeRate),
      );
    }
  }, [exchangeRate]);

  useEffect(() => {
    if (inputReceivedAmount && inputType === "dollar") {
      setReceivedAmount(inputReceivedAmount);
    } else {
      setReceivedAmount(inputReceivedAmount / exchangeRate);
    }
  }, [inputReceivedAmount, inputType]);

  useEffect(() => {
    if (exchangeRate) {
      window.localStorage.setItem("exchangeRate", JSON.stringify(exchangeRate));
    }
  }, [exchangeRate]);

  return (
    <Dialog
      fullWidth
      open={open}
      className="dialog-container"
      maxWidth="xl"
      hideBackdrop={hideBackdrop}
    >
      <DialogTitleComp
        title={t("modal_title_create_invoice")}
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={3}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_invoice_id")}
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    height: "40px",
                    bgcolor: "#F2F2F2",
                    padding: "8.5px 14px",
                    borderRadius: 1,
                  }}
                >
                  <Typography
                    className={t("class-name-field-title")}
                    sx={{ fontWeight: "bold" }}
                  >
                    {generateInvoiceNumber(data?.getNextInvoiceId)}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_invoice_type")}
                </Typography>
                <FormControl fullWidth size="small" className="text-field">
                  <Select {...getFieldProps("invoiceType")}>
                    <MenuItem value={"student"}>{t("thead_student")}</MenuItem>
                    <MenuItem value={"other"}>{t("thead_other")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {!studentId && (
                <Grid item xs={3}>
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_student")} / {t("thead_other")}
                  </Typography>
                  <SelectStudent
                    studentType="direct"
                    buttonAdd={false}
                    value={values?.studentId}
                    onChange={(val) => setFieldValue("studentId", val)}
                    className="text-field"
                  />
                  {!!errors.studentId?.id && touched.studentId?.id && (
                    <FormHelperText error id="outlined-adornment-password">
                      {errors.studentId?.id}
                    </FormHelperText>
                  )}
                </Grid>
              )}
              <Grid item xs={3}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_class")}
                </Typography>
                <SelectEnrollmentByStudent
                  studentId={values?.studentId?.id}
                  value={values?.enrollmentId}
                  onChange={(val) => setFieldValue("enrollmentId", val)}
                  className="text-field"
                />
                {!!errors.enrollmentId?.id && touched.enrollmentId?.id && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.enrollmentId?.id}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} md={12}>
                <ItemList
                  required={required}
                  listItemData={listItemData}
                  setListItemData={setListItemData}
                />
              </Grid>
              {/* =============================================== Exchange rate =================================== */}
              <Grid item xs={9}></Grid>
              <Grid item xs={3}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_exchange_rate")}
                </Typography>
                <TextField
                  type="number"
                  fullWidth
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <Typography className={t("class-name-field-title")}>
                        ៛
                      </Typography>
                    ),
                  }}
                  className="text-field"
                  placeholder={t("thead_exchange_rate")}
                  value={exchangeRate}
                  onChange={(e) => {
                    if (e.target.value <= 0) {
                      setExchangeRate(exchangeRate);
                    } else {
                      setExchangeRate(e.target.value);
                    }
                  }}
                  // onBlur={(e) => {
                  //   updateExchangeRate({
                  //     variables: { exchangeRate: parseFloat(e.target.value) },
                  //   });
                  // }}
                />
              </Grid>
              {/* =============================================== Riel amount =================================== */}
              <Grid item xs={9}></Grid>
              <Grid item xs={3}>
                <Stack
                  sx={{
                    width: "100%",
                    height: "40px",
                    bgcolor: "#F2F2F2",
                    padding: "8.5px 14px",
                    borderRadius: 1,
                  }}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_total_riel_amount")} :
                  </Typography>
                  <Typography
                    className={t("class-name-field-title")}
                    sx={{ fontWeight: "bold" }}
                  >
                    {currencyFormatRiel(totalAmount * exchangeRate)} ៛
                  </Typography>
                </Stack>
              </Grid>
              {/* =============================================== Dollar amount =================================== */}
              <Grid item xs={9}></Grid>
              <Grid item xs={3}>
                <Stack
                  sx={{
                    width: "100%",
                    height: "40px",
                    bgcolor: "#F2F2F2",
                    padding: "8.5px 14px",
                    borderRadius: 1,
                  }}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_total_amount")} :
                  </Typography>
                  <Typography
                    className={t("class-name-field-title")}
                    sx={{ fontWeight: "bold" }}
                  >
                    $ {currencyFormat(totalAmount)}
                  </Typography>
                </Stack>
              </Grid>
              {/* =============================================== Input amount =================================== */}
              <Grid item xs={7}></Grid>
              <Grid item xs={2}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_amount_type")}
                </Typography>
                <FormControl fullWidth size="small" className={"text-field"}>
                  <Select
                    value={inputType}
                    onChange={(e) => {
                      setInputType(e?.target?.value);
                      setInputReceivedAmount(0);
                    }}
                  >
                    <MenuItem value={"dollar"}>Dollar</MenuItem>
                    <MenuItem value={"riel"}>Riel</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_input_amount")}
                </Typography>
                <TextField
                  type="number"
                  fullWidth
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <Typography className={t("class-name-field-title")}>
                        {inputType === "dollar" ? "$" : "៛"}
                      </Typography>
                    ),
                  }}
                  className="text-field"
                  placeholder={t("thead_input_amount")}
                  value={inputReceivedAmount}
                  onChange={(e) => {
                    const inputVal = parseFloat(e.target.value);
                    // console.log("inputVal::", inputVal);
                    if (inputVal <= 0) {
                      setInputReceivedAmount(0);
                    } else {
                      setInputReceivedAmount(inputVal);
                    }
                  }}
                />
              </Grid>
              {/* =============================================== Total Owe amount =================================== */}
              <Grid item xs={9}></Grid>
              <Grid item xs={3}>
                <Stack
                  sx={{
                    width: "100%",
                    height: "40px",
                    bgcolor: "#F2F2F2",
                    padding: "8.5px 14px",
                    borderRadius: 1,
                  }}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_owe_amount")} :
                  </Typography>

                  <Typography
                    className={t("class-name-field-title")}
                    sx={{ fontWeight: "bold", color: "red !important" }}
                  >
                    ${" "}
                    {currencyFormat(
                      minuseTwoNumber(totalAmount, receivedAmount),
                    )}
                  </Typography>
                </Stack>
              </Grid>
              {/* <Grid item xs={9}></Grid>
              <Grid item xs={3}>
                <Stack
                  sx={{
                    width: "100%",
                    height: "40px",
                    bgcolor: "#F2F2F2",
                    padding: "8.5px 14px",
                    borderRadius: 1,
                  }}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_owe_amount")} :
                  </Typography>

                  <Typography
                    className={t("class-name-field-title")}
                    sx={{ fontWeight: "bold", color: "red !important" }}
                  >
                    {currencyFormat(
                      minuseTwoNumber(totalAmount, receivedAmount)
                    )}{" "}
                    ៛
                  </Typography>
                </Stack>
              </Grid> */}
              <Grid item xs={12} md={12}>
                <AlertList
                  listItemData={alertItemData}
                  setListItemData={setAlertItemData}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_remark")}
                </Typography>
                <TextField
                  minRows={2}
                  multiline
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>
              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    fullWidth
                    onClick={handleSubmit}
                    className={t("class-btn-create")}
                  >
                    {dialogTitle === "Update" ? t("update") : t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
